const { merge } = require("lodash");
const joi = require("joi");
const { JOI_LANGUAGE_ERRORS } = require("@dpdgroupuk/mydpd-enums");
const constants = require("./constants");

exports.Joi = joi;

const language = merge({}, JOI_LANGUAGE_ERRORS, constants.LANGUAGE.errors);

exports.labels = constants.LANGUAGE.labels;
exports.errors = constants.LANGUAGE.errors;
// @see: https://joi.dev/api/?v=15.1.1#validatevalue-schema-options-callback
exports.options = exports.modelOptions = {
  abortEarly: false,
  language,
};

exports.fieldOptions = {
  abortEarly: false,
  language,
};
